import DwchatSpace from './dwchat_space';
import {
  get_date_from_now,
  mark_message_read,
  get_time,
  get_avatar_html,
  set_notification_count,
} from './dwchat_utils';

export default class DwchatRoom {
  constructor(opts) {
    this.$wrapper = opts.$wrapper;
    this.$dwchat_rooms_container = opts.$dwchat_rooms_container;
    this.dwchat_list = opts.dwchat_list;
    this.profile = opts.element;
    this.setup();
    if (!this.profile.is_read) {
      set_notification_count('increment');
    }
  }

  setup() {
    this.$dwchat_room = $(document.createElement('div'));
    this.$dwchat_room.addClass('dwchat-room');

    this.avatar_html = get_avatar_html(
      this.profile.room_type,
      this.profile.opposite_person_email,
      this.profile.room_name
    );

    let last_message = this.sanitize_last_message(this.profile.last_message);

    const info_html = `
			<div class='dwchat-profile-info'>
				<div class='dwchat-name'>
					${__(this.profile.room_name)} 
					<div class='dwchat-latest' 
						style='display: ${this.profile.is_read ? 'none' : 'inline-block'}'
					></div>
				</div>
				<div style='color: ${
          this.profile.is_read ? 'var(--text-muted)' : 'var(--text-color)'
        }' class='last-message'>${__(last_message)}</div>
			</div>
		`;
    const date_html = `
			<div class='dwchat-date'>
				${__(get_date_from_now(this.profile.last_date, 'room'))}
			</div>
		`;
    let inner_html = '';

    inner_html += this.avatar_html + info_html + date_html;

    this.$dwchat_room.html(inner_html);
  }

  sanitize_last_message(message) {
    let sanitize_last_message = $('<div>').text(message).html();
    if (sanitize_last_message) {
      if (sanitize_last_message.length > 20) {
        sanitize_last_message = sanitize_last_message.substring(0, 20) + '...';
      }
    }
    return sanitize_last_message;
  }

  set_as_read() {
    this.profile.is_read = 1;
    this.$dwchat_room.find('.last-message').css('color', 'var(--text-muted)');
    this.$dwchat_room.find('.dwchat-latest').hide();
    set_notification_count('decrement');
  }

  set_last_message(message, date) {
    const sanitized_message = this.sanitize_last_message(message);
    this.$dwchat_room.find('.last-message').html(__(sanitized_message));
    this.$dwchat_room.find('.dwchat-date').text(__(get_time(date)));
  }

  set_as_unread() {
    if (this.profile.is_read) {
      set_notification_count('increment');
    }
    this.profile.is_read = 0;
    this.$dwchat_room.find('.last-message').css('color', 'var(--text-color)');
    this.$dwchat_room.find('.dwchat-latest').show();
  }

  render(mode) {
    if (mode == 'append') {
      this.$dwchat_rooms_container.append(this.$dwchat_room);
    } else {
      this.$dwchat_rooms_container.prepend(this.$dwchat_room);
    }

    this.setup_events();
  }

  move_to_top() {
    $(this.$dwchat_room).prependTo(this.$dwchat_rooms_container);
  }

  setup_events() {
    this.$dwchat_room.on('click', () => {
      if (typeof this.dwchat_space !== 'undefined') {
        this.dwchat_space.render();
      } else {
        this.dwchat_space = new DwchatSpace({
          $wrapper: this.$wrapper,
          dwchat_list: this.dwchat_list,
          profile: this.profile,
        });
      }
      if (this.profile.is_read === 0) {
        mark_message_read(this.profile.room);
        this.set_as_read();
      }
    });
  }
}
